// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iw5AK","delete":"styles_delete__2Da5N","update":"styles_update__3nqrv","add":"styles_add__3drml"};